import {MultiSelectChipInput, MultiSelectChipInputProps} from "~/apps/core/ui/ChipInput/MultiSelectChipInput";
import {TerminalReleaseState, TerminalReleaseStatusList} from "~/apps/packages/warehouse-closure/queries";
import {getTerminalReleaseStatusColor, humanizeTerminalReleaseState} from "~/apps/packages/warehouse-closure/utils";
import React, {useMemo} from "react";
import {FiberManualRecord} from "@mui/icons-material";
import {Grid} from "@mui/material";


export type TerminalReleaseStatesChipInputProps = Omit<MultiSelectChipInputProps<TerminalReleaseState>, "options" | "title">;


export const TerminalReleaseStatesChipInput = (props: TerminalReleaseStatesChipInputProps) => {
    const {value: oValue, onChange, ...other} = props;

    const titleValuesMap = useMemo(() => {
        const groups = new Map<string, Set<TerminalReleaseState>>();
        for (const state of TerminalReleaseStatusList) {
            const title = humanizeTerminalReleaseState(state);
            if (!groups.has(title)) {
                groups.set(title, new Set());
            }
            groups.get(title).add(state);
        }
        return groups;
    }, []);

    const iValue = useMemo(() => {
        const iValue = [];
        const oValueAsSet = new Set(oValue || []);
        for (const [title, values] of titleValuesMap.entries()) {
            const noMatch = [...values].find(v => !oValueAsSet.has(v))
            if (!noMatch){
                iValue.push(title);
            }
        }
        return iValue;
    }, [oValue, titleValuesMap]);

    const options = useMemo(() => {
        const options = [];
        for (const [title, value] of titleValuesMap.entries()) {
            options.push({
                value: title,
                title: (
                    <Grid container alignItems="center">
                        <FiberManualRecord style={{color: getTerminalReleaseStatusColor(value.values().next().value), width: 8, marginRight: 8}}/>
                        {title}
                    </Grid>
                )
            });
        }
        return options;
    }, [titleValuesMap]);


    const handleChange = (value) => {
        value = value || [];
        const outValue = [];
        for (const title of value) {
            outValue.push(...titleValuesMap.get(title));
        }
        onChange && onChange(outValue);
    }


    return (
        <MultiSelectChipInput
            {...other}
            title="Статус"
            options={options}
            value={iValue}
            onChange={handleChange}
        />
    )
}